import React, { useState, useEffect } from "react";
import styles from "./edit-contact-modal.module.css";
import Input from "../../ui/input";
import Button from "../../ui/button";
import Dropdown from "../../ui/dropdown";
import { MyIcons } from "../../icons/my-icons";
import { showErrorToast } from "../../../utils/notifications";

const EditContactModal = ({ isOpen, onClose, contact, onSave, rolOptions, simpleMode = false }) => {
  const [formData, setFormData] = useState({
    nombre: "",
    telefono: "",
    direccion: "",
    info: "",
    contactoRol: null,
  });

  useEffect(() => {
    if (contact) {
      
      // Si el rol es un objeto con value, usarlo directamente
      // Si no, buscar en rolOptions por value
      let selectedRol = null;
      if (contact.rol) {
        if (typeof contact.rol === 'object' && contact.rol.value) {
          selectedRol = contact.rol;
        } else if (typeof contact.rol === 'string') {
          selectedRol = rolOptions?.find(opt => opt.value === contact.rol) || null;
        }
      }


      setFormData({
        nombre: contact.name || "",
        telefono: contact.phone || "",
        direccion: contact.address || "",
        info: contact.info || "",
        contactoRol: selectedRol,
      });
    }
  }, [contact, rolOptions]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleRolSelect = (option) => {
    setFormData({ ...formData, contactoRol: option });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validar que el nombre esté presente
    if (!formData.nombre.trim()) {
        showErrorToast("El nombre es obligatorio");
      return;
    }
    
    const updatedContact = {
      ...contact,
      name: formData.nombre,
      phone: formData.telefono,
      address: formData.direccion, // ✅ Ahora se guarda la dirección correctamente
      info: formData.info,
      rol: formData.contactoRol,
    };

    onSave(updatedContact);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>Editar Contacto</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <MyIcons name="close" width={20} height={20} color="var(--dark-grey)" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label className={styles.label}>Nombre</label>
              <Input
                name="nombre"
                value={formData.nombre}
                onChange={handleInputChange}
                placeholder="Nombre del contacto"
              />
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>Teléfono</label>
              <Input
                name="telefono"
                value={formData.telefono}
                onChange={handleInputChange}
                placeholder="Teléfono"
              />
            </div>
          </div>

          {!simpleMode && (
            <>
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label className={styles.label}>Dirección</label>
                  <Input
                    name="direccion"
                    value={formData.direccion}
                    onChange={handleInputChange}
                    placeholder="Dirección"
                  />
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.label}>Información adicional</label>
                  <Input
                    name="info"
                    value={formData.info}
                    onChange={handleInputChange}
                    placeholder="Información adicional"
                  />
                </div>
              </div>

              <div className={styles.formGroup}>
                <label className={styles.label}>Rol</label>
                <Dropdown
                  options={rolOptions}
                  onSelect={handleRolSelect}
                  selected={formData.contactoRol}
                  placeholder="Seleccionar rol"
                />
              </div>
            </>
          )}

          <div className={styles.actions}>
            <Button type="button" variant="secondary" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit" variant="primary">
              Guardar
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditContactModal;
